import React from "react";
import { empresaTipoLabel } from "../adapters/empresasAdapter";

const tipoBadgeClass = (tipo) => {
  switch ((tipo || "").toLowerCase()) {
    case "interna":
      return "bg-success-subtle text-success";
    case "proveedor":
      return "bg-warning-subtle text-warning";
    default:
      return "bg-info-subtle text-info";
  }
};

export default function EmpresasTable({
  empresas,
  loading,
  error,
  reload,
  seleccionadoId,
  onSelect,
  onEdit,
  onDelete,
  canEdit = true,
  canDelete = true,
  maxHeight = "60vh",
}) {
  if (loading) {
    return (
      <div className="management-card text-center py-5">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="management-card management-alert d-flex justify-content-between align-items-center">
        <span>{error}</span>
        {reload && (
          <button className="btn btn-outline-secondary btn-sm" onClick={reload}>
            Reintentar
          </button>
        )}
      </div>
    );
  }

  if (!empresas.length) {
    return (
      <div className="management-card dashboard-empty text-center py-5">
        <i className="bi bi-buildings dashboard-empty-icon mb-3" />
        <h5 className="fw-semibold mb-1">No hay empresas registradas.</h5>
        <p className="text-muted mb-0">Crea una empresa o ajusta los filtros.</p>
      </div>
    );
  }

  return (
    <div className="management-card emp-table-card">
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <div>
          <p className="management-label mb-1">Listado</p>
          <h6 className="mb-0">Empresas registradas</h6>
        </div>
        {reload && (
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={reload}
            disabled={loading}
          >
            <i className="bi bi-arrow-repeat me-2" />
            Actualizar
          </button>
        )}
      </div>
      <div className="management-table-wrapper" style={{ maxHeight }}>
        <table className="table align-middle management-table emp-table mb-0">
          <thead className="bg-transparent">
            <tr>
              <th>#</th>
              <th>Empresa</th>
              <th>RUC</th>
              <th>Contacto</th>
              <th>Tipo</th>
              <th className="text-center">Estado</th>
              <th className="text-end">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {empresas.map((emp, idx) => {
              const rowKey = emp.id !== undefined && emp.id !== null ? `emp-${emp.id}-${idx}` : `emp-temp-${idx}`;
              const isSelected = seleccionadoId === emp.id;
              return (
                <tr
                  key={rowKey}
                  className={isSelected ? "selected-row" : ""}
                  onClick={() => onSelect?.(emp)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onSelect?.(emp);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <td className="fw-semibold">{idx + 1}</td>
                  <td>
                    <div className="fw-semibold">{emp.nombre || "Sin nombre"}</div>
                    <small className="text-muted">{emp.createdAt ? new Date(emp.createdAt).toLocaleDateString() : "Sin fecha"}</small>
                  </td>
                  <td>{emp.ruc || "N/D"}</td>
                  <td>
                    <div>{emp.telefono || "Sin telefono"}</div>
                    <small className="text-muted">{emp.email || "Sin correo"}</small>
                  </td>
                  <td>
                    <span className={`badge rounded-pill ${tipoBadgeClass(emp.tipo)}`}>
                      {empresaTipoLabel(emp.tipo)}
                    </span>
                  </td>
                  <td className="text-center">
                    <span
                      className={`badge rounded-pill px-3 py-2 ${
                        emp.activo ? "bg-success-subtle text-success" : "bg-secondary-subtle text-muted"
                      }`}
                    >
                      {emp.activo ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex justify-content-end gap-2">
                      {canEdit && (
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm management-action-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            onEdit?.(emp);
                          }}
                          title="Editar"
                        >
                          <i className="bi bi-pencil-square" />
                        </button>
                      )}
                      {canDelete && (
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm management-action-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDelete?.(emp);
                          }}
                          title="Eliminar"
                        >
                          <i className="bi bi-trash" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

